import { Component, Input, inject } from '@angular/core';

import { I18nService } from '../services/i18n.service';

/** Centered white card used by every auth page. Hosts a language toggle in
 *  the top-right that swaps the {@code /:lang/} segment in the URL — same
 *  UX as the legacy Thymeleaf templates. */
@Component({
  selector: 'auth-card',
  standalone: true,
  template: `
    <div class="au-shell">
      <div class="au-card">
        <button type="button" class="au-lang" (click)="switchLang()" [title]="otherLangName">
          {{ otherLangName }}
        </button>
        @if (titleText) { <h1 class="au-card__title">{{ titleText }}</h1> }
        @if (subtitle)  { <p class="au-card__sub">{{ subtitle }}</p> }
        <ng-content/>
      </div>
    </div>
  `,
  styles: [`
    .au-card { position: relative; }
    .au-lang {
      position: absolute;
      top: 12px;
      right: 12px;
      background: transparent;
      border: 1px solid var(--au-border, rgba(0,0,0,.12));
      color: var(--au-text-soft, #5a6573);
      padding: 4px 10px;
      border-radius: 999px;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: background .15s, color .15s, border-color .15s;
    }
    .au-lang:hover { background: var(--au-primary, #195db0); color: #fff; border-color: transparent; }
  `],
})
export class AuthCardComponent {
  @Input('title') titleText: string = '';
  @Input() subtitle: string = '';

  protected i18n = inject(I18nService);

  protected get otherLangCode(): string {
    return this.i18n.t('lang.other.code') || 'kz';
  }

  protected get otherLangName(): string {
    return this.i18n.t('lang.other.name') || 'Қазақша';
  }

  switchLang(): void {
    const path = window.location.pathname;
    const target = this.otherLangCode;
    const next = path.replace(/^\/(ru|kz|kk)(\/|$)/, `/${target}$2`);
    if (next === path) return;
    window.location.href = next + window.location.search + window.location.hash;
  }
}
